import { render, staticRenderFns } from "./_ActiveDepartments.vue?vue&type=template&id=0633e02c&"
import script from "./_ActiveDepartments.vue?vue&type=script&lang=ts&"
export * from "./_ActiveDepartments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports